// extracted by mini-css-extract-plugin
module.exports = {"applicationAuthorizeForm":"ApplicationAuthorize_applicationAuthorizeForm_1tjMf"};